module.exports = __webpack_public_path__ + "static/media/invalid.23b4ae58.mp3";